import React, {Component} from 'react';
import ReactHtmlParser from 'react-html-parser';
class LogoDisclaimer extends Component {
    render() {
        if(this.props.disclaimer){
            return <div class="product-details--logo-disclaimer"> { ReactHtmlParser (this.props.disclaimer) } </div>
        }
        return (null)
    }
}

export default LogoDisclaimer;


// WEBPACK FOOTER //
// ./src/Components/Elements/LogoDisclaimer/LogoDisclaimer.js